import React , {useState, useEffect} from 'react';
import {MenuItem} from "./MenuItem"

export function MenuHeader ({item, Page, title, checkMenuChange}) {

  const [menuItems, setMenuItems] = useState(item) ;
  const [page] = useState(Page) ;


  useEffect(()=>{
    if(item !== null && item !== menuItems){
      setMenuItems(item)
    }
  }, [item, menuItems])

    return (
      <>
      <li>
         <h4 className="h4color">{title}</h4>          
      </li>
        {
          menuItems.items.map((titleItem, index) =>(
            <MenuItem key={"MenuItem"+titleItem.menuId} items={titleItem} index={index} Page={page} checkMenuChange={checkMenuChange} />
          ))
        }
      </>
    )
  }